import baseModule from "./baseModule";

class category extends baseModule("category") {}
const vuexData = new category();
export default { ...vuexData };
